import { isLocale, type locales } from "../../../paraglide/runtime.js"

/** Locales from `project.inlang/settings.json`, via the generated tuple. */
export type Locale = (typeof locales)[number]

export const FALLBACK_LOCALE: Locale = "ru"

/** Case-sensitive: `"EN"` is not a locale and resolves to the fallback. */
export function resolveLocale(value: string | null | undefined): Locale {
	if (isLocale(value)) {
		return value
	}
	return FALLBACK_LOCALE
}
